import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment, useCallback } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import AssociateContactToThreadPrompt from '../../crm-integration/components/AssociateContactToThreadPrompt';
import { getClickedToAssociateCrmObject } from '../../crm-integration/constants/Events';
import { ASSOCIATE_PROMPT } from '../../crm-integration/constants/PromptTypes';
import { usePromptReducer } from '../../crm-integration/hooks/usePromptReducer';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { isFilteredView, isTrashView } from 'find-and-filter-data/views-schema/public';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssociateContactToThreadButton = ({
  threadId
}) => {
  const {
    openPrompt,
    closePrompt,
    promptStatus
  } = usePromptReducer();
  const currentView = useCurrentView();
  const openAssociateModal = useCallback(() => {
    trackEvent(getClickedToAssociateCrmObject());
    openPrompt(ASSOCIATE_PROMPT);
  }, [openPrompt]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "ticket-header-associate-unknown-visitor-button",
      onClick: openAssociateModal,
      disabled: isFilteredView(currentView) || isTrashView(currentView),
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.header.associateContactLabel"
      })
    }), /*#__PURE__*/_jsx(AssociateContactToThreadPrompt, {
      closePrompt: closePrompt,
      promptStatus: promptStatus,
      threadId: threadId
    })]
  });
};
AssociateContactToThreadButton.displayName = 'AssociateContactToThreadButton';
export default AssociateContactToThreadButton;